export const InvestorTypeOptions = [
  // { label: "-", value: "" },
  { label: "Venture Capital", value: "venture_capital" },
  { label: "Corporate Venture Capital", value: "corporate_venture_capital" },
  { label: "Family Investment Office", value: "family_investment_office" },
  { label: "micro VC", value: "micro_vc" },
  { label: "Private Equity Firm", value: "private_equity_firm" },
  { label: "Venture Debt", value: "venture_debt" },
]
